import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { getClassNames, isBrowser } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmTimetable, IconLlmPin } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import { Cta } from '../../components/Cta/cta.js';

const Poi = props => {
  const {
    item
  } = props;
  const label = useLabel();
  const {
    decorateUrl
  } = useLlm(state => state.actions);
  const {
    send
  } = useLlmView(state => state.actions);
  const onTellMeMore = event => __awaiter(void 0, void 0, void 0, function* () {
    const prompt = `${label('llm.tellMeMoreAbout')} ${item.title}`;
    yield send(prompt, response => {
      // console.log('Prompt.onChunk', response.chunks);
    }, response => {
      // console.log('Prompt.onEnd', response);
    });
  });
  const onGoToWebsite = event => __awaiter(void 0, void 0, void 0, function* () {
    if (isBrowser) {
      event.preventDefault();
      const url = yield decorateUrl(item, item.url);
      window.open(url, '_blank');
    }
  });
  const classNames = getClassNames('llm__poi', {
    [`llm__poi--${item.type}`]: !!item.type
  });
  return jsxs("div", {
    className: classNames,
    children: [item.image && jsx("div", {
      className: "llm__poi-media",
      children: jsx("img", {
        src: item.image,
        alt: ""
      })
    }), jsxs("div", {
      className: "llm__poi-content",
      children: [item.title && jsx("div", {
        className: "llm__poi-title",
        dangerouslySetInnerHTML: {
          __html: item.title
        }
      }), item.abstract && jsx("div", {
        className: "llm__poi-body",
        dangerouslySetInnerHTML: {
          __html: item.abstract
        }
      }), (item.time || item.place) && jsxs("div", {
        className: "llm__poi-tags",
        children: [item.time && jsxs("div", {
          className: "llm__poi-tag llm__poi-time",
          children: [jsx(IconLlmTimetable, {}), item.time]
        }), item.place && jsxs("div", {
          className: "llm__poi-tag llm__poi-location",
          children: [jsx(IconLlmPin, {}), item.place]
        })]
      }), jsxs("div", {
        className: "llm__poi-ctas",
        children: [jsx(Cta, {
          type: "button",
          label: label('llm.tellMeMore'),
          onClick: onTellMeMore
        }), jsx(Cta, {
          type: "text",
          label: label('llm.goToWebsite'),
          onClick: onGoToWebsite
        })]
      })]
    })]
  });
};

export { Poi };
//# sourceMappingURL=poi.js.map
